module.exports = "/assets/last_places.png?L7a6I7K";